{
  "title": "Members",
  "description": "Everyone in this school — staff, pupils and parents.",
  "invite": "Invite",
  "searchPlaceholder": "Search by name or email…",
  "tabs": {
    "members": "Members",
    "invitations": "Invitations",
    "family": "Family links"
  },
  "filters": {
    "status": "Status",
    "allStatuses": "All statuses",
    "active": "Active",
    "inactive": "Deactivated",
    "segment": "Who to show",
    "allClasses": "All classes",
    "schoolClass": "Class"
  },
  "table": {
    "name": "Name",
    "email": "Email",
    "role": "Role",
    "joined": "Joined",
    "status": "Status"
  },
  "status": {
    "active": "Active",
    "inactive": "Deactivated"
  },
  "empty": {
    "title": "No members found",
    "text": "Invite teachers, pupils and parents to build up the school.",
    "filterText": "Nothing matches the current filters."
  },
  "actions": {
    "deactivate": "Deactivate",
    "reactivate": "Reactivate",
    "deactivateTitle": "Deactivate {{name}}?",
    "deactivateDescription": "They lose access to this school, but their history stays attributed. You can reactivate them at any time.",
    "reactivateTitle": "Reactivate {{name}}?",
    "reactivateDescription": "They regain access to this school with the same role.",
    "deactivated": "Member deactivated",
    "reactivated": "Member reactivated",
    "setPassword": "Set password"
  },
  "family": {
    "add": "Link a parent",
    "unlink": "Unlink",
    "unlinked": "Link removed",
    "unlinkTitle": "Unlink {{parent}} from {{pupil}}?",
    "unlinkDescription": "The parent loses access to this pupil's work and can no longer message them. The pupil's own records are untouched, and you can link them again later.",
    "filters": {
      "pupil": "Pupil",
      "allPupils": "All pupils",
      "parent": "Parent",
      "allParents": "All parents",
      "clear": "Clear filters"
    },
    "table": {
      "pupil": "Pupil",
      "parent": "Parent",
      "linked": "Linked"
    },
    "empty": {
      "title": "No family links yet",
      "text": "Link a parent to their child so they can follow that pupil's work. Accepting a parent invitation creates the link automatically — this is for families already in the school.",
      "filterTitle": "No links match these filters",
      "filterText": "This pupil or parent has no link recorded. Clear the filters to see the whole school."
    },
    "dialog": {
      "title": "Link a parent to a pupil",
      "description": "Pick a pupil and one of their parents. Both must already be members of this school.",
      "pupilPlaceholder": "Choose a pupil",
      "parentPlaceholder": "Choose a parent",
      "pupilRequired": "Choose a pupil",
      "parentRequired": "Choose a parent",
      "noPupils": "No pupils in this school yet — invite them first.",
      "noParents": "No parent members yet — invite a parent first.",
      "submit": "Link",
      "success": "Parent linked"
    }
  },
  "segments": {
    "staff": "Staff",
    "pupil": "Pupils",
    "parent": "Parents"
  },
  "createPupil": {
    "open": "Create pupil account",
    "title": "Create a pupil account",
    "description": "For pupils without a working mailbox: invent a school-style login email, set a password, and hand the credentials to the pupil. Anyone with a real address should be invited instead.",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Login email",
    "emailHint": "A login, not a mailbox — it is marked verified immediately, so never use someone's real address.",
    "password": "Password",
    "regenerate": "Generate a new password",
    "submit": "Create account",
    "cancel": "Cancel",
    "firstNameRequired": "First name is required.",
    "lastNameRequired": "Last name is required.",
    "emailInvalid": "Enter a valid email-shaped login.",
    "passwordTooShort": "At least 8 characters."
  },
  "setPassword": {
    "title": "Set a password for {{name}}",
    "description": "The new password replaces the old one immediately. Copy it and hand it to the pupil — it is shown only once.",
    "password": "New password",
    "regenerate": "Generate a new password",
    "submit": "Set password",
    "cancel": "Cancel"
  },
  "credentials": {
    "warning": "Shown only once — copy the credentials now and pass them to the pupil. Closing this window without copying means setting a new password.",
    "label": "Login and password",
    "copy": "Copy credentials",
    "copied": "Credentials copied.",
    "copyFailed": "Could not copy — select and copy manually.",
    "acknowledge": "Done, I copied them"
  }
}
